import React, { FC } from "react";
import { observer } from "mobx-react";  
import { UpsertCheckoutActiveStep } from "../enums";
import { SideBarContainer, SidebarSelectors } from "../styles";
import { CustomLabel } from "@mindmemobile/mm-shared-global";
import { CheckOutStore } from "../store";


interface IStepData<T> {
  step: T;
  icon: string;
  activeIcon: string;
  title: string;
  className?: string;
}

interface IProps<T> {
  activeStep: T;
  showVariant: boolean;
  className: '';
  stepsData: IStepData<T>[];
  onTabChange: (key: string) => void;
  checkoutStore: CheckOutStore;
}

const CustomSideBar: FC<IProps<any>> = ({ activeStep, stepsData, onTabChange }) => {
  const isStepClickable = (step: UpsertCheckoutActiveStep) => {
      const stepsOrder = [
          UpsertCheckoutActiveStep.Detail,
          UpsertCheckoutActiveStep.Sell,
          UpsertCheckoutActiveStep.Pay,
          UpsertCheckoutActiveStep.AfterPay,
          UpsertCheckoutActiveStep.Options,
      ];

      const activeStepIndex = stepsOrder.indexOf(activeStep as UpsertCheckoutActiveStep);
      const stepIndex = stepsOrder.indexOf(step);

      return stepIndex <= activeStepIndex;
  };

  const handleTabChange = (key: string) => {
      onTabChange(key);
  };

  return (
      <SideBarContainer>
          {stepsData.map(({ step, icon, activeIcon, title, className }) => {
              const isActive = activeStep === step;
              const clickable = isStepClickable(step);
              return (
                  <SidebarSelectors
                      key={title}
                      className={`${isActive ? 'active' : ''} ${clickable ? 'clickable' : ''} ${className || ''}`}
                      onClick={() => {
                          handleTabChange(step);
                      }}
                      // style={{ cursor: clickable ? 'pointer' : 'not-allowed', opacity: clickable ? 1 : 0.5 }}
                  >
                      <img src={isActive ? activeIcon : icon} alt={title} />
                      <CustomLabel className={isActive ? 'active' : ''}>{title}</CustomLabel>
                  </SidebarSelectors>
              );
          })}
      </SideBarContainer>
  );
};

export default observer(CustomSideBar);
